import { appStore } from '@web-app/atoms/appStore';
import { providerTimezoneAtom } from '@web-app/atoms/scheduling/schedulingStateAtoms';
import { resolveProviderTimezone } from '@web-app/utils/date-time.utils';
import { trpc } from '@web-app/utils/trpc';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

const STORE = { store: appStore };

/** Canonical provider timezone for scheduling display, queries, and writes. */
export function useProviderTimezone() {
  const { data, isError, isPending } = trpc.availability.getProfile.useQuery();
  const setTimezoneBridge = useSetAtom(providerTimezoneAtom, STORE);
  const healthieTimezone = data?.timezone ?? '';
  const timezone = resolveProviderTimezone(healthieTimezone);
  const status = isPending
    ? 'loading'
    : isError || !timezone
      ? 'error'
      : 'ready';

  useEffect(
    function syncTimezoneState() {
      setTimezoneBridge(status === 'ready' ? timezone : null);
    },
    [setTimezoneBridge, status, timezone],
  );

  return {
    profile: data,
    timezone: status === 'ready' ? timezone : null,
    status,
  };
}
